module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/home/home.component.css
// module id = ./src/app/view/home/home.component.css
// module chunks = main